<template>
  <div class="page-login">
    <header>
      <div class="content">
        <a href="/"><img src="/images/logo.svg" class="header-logo" /></a>
        <a href="/login" class="header-button-si">Sign In</a>
      </div>
    </header>
    <section class="login">
      <div class="content">
        <div class="login-form">
          <form id="registerform" @submit.prevent="submit" @keydown="registerForm.errors.clear($event.target.name)">
              <h1>Discover the most suitable investors for&nbsp;you!</h1>

              <div v-if="is_completed">
                <p>Please book a video call with us by selecting a suitable time slot in the calendar below.</p>
                <!-- <iframe width="100%" style="border:0;max-width:1200px;height:1050px" height="1050" border="0" frameborder="0" src="https://calendly.com/proptecham/introduction?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe>
                <iframe width="100%" style="border:0;max-width:1200px;height:1130px" height="1130" border="0" frameborder="0" src="https://calendly.com/d/4dt-7ct-5x9/introduction-call-with-proptecham-ai?hide_gdpr_banner=1&text_color=20365f&primary_color=34a7c2"></iframe>
                -->
                <iframe width="100%" style="border:0;max-width:1200px;height:1130px" height="1130" border="0" frameborder="0" src="https://calendly.com/d/4dt-7ct-5x9/introduction-call-with-proptecham-ai"></iframe>
                <p>You should have also received an email from us containing details to log into your account. Please check your spam folder if you can’t find this in your inbox.</p>
              </div>
            <div v-else>
              <p>Our AI provides tailored investor insights that match your specific requirements.<br /><br />
                Simply fill out the brief questionnaire below to obtain your personalised investor list at no cost.
              </p>

              <label for="first_name">{{ trans('auth.first_name') }}</label>
              <input type="text" name="first_name" v-model="registerForm.first_name" />
              <show-error :form-name="registerForm" prop-name="first_name"></show-error>

              <label for="last_name">{{ trans('auth.last_name') }}</label>
              <input type="text" name="last_name" v-model="registerForm.last_name" />
              <show-error :form-name="registerForm" prop-name="last_name"></show-error>
<!--
              <label for="company">{{ trans('auth.company') }}</label>
              <input type="text" name="company" v-model="registerForm.company" />
              <show-error :form-name="registerForm" prop-name="company"></show-error>
-->
              <label for="email">{{ trans('auth.email') }}</label>
              <input type="text" name="email" v-model="registerForm.email" />
              <show-error :form-name="registerForm" prop-name="email"></show-error>
<!--
              <label for="phone">{{ trans('auth.phone') }}</label>
              <input type="text" name="phone" v-model="registerForm.phone" />
              <show-error :form-name="registerForm" prop-name="phone"></show-error>

              <label for="password">{{ trans('auth.password') }}</label>
              <input type="password" name="password" v-model="registerForm.password" />
              <show-error :form-name="registerForm" prop-name="password"></show-error>

              <label for="password_confirmation">{{ trans('auth.confirm_password') }}</label>
              <input type="password" name="password_confirmation" v-model="registerForm.password_confirmation" />
              <show-error :form-name="registerForm" prop-name="password_confirmation"></show-error>
-->

            <label>Your Company’s Name</label>
            <input type="text" class="pta-form-text" v-model="registerForm.company" style="margin-bottom:0;" />
            <show-error :form-name="registerForm" prop-name="company"></show-error>

            <label style="padding-top:20px;">Your Work Phone Number</label>
            <input type="text" maxlength="50" class="pta-form-text" @keydown="filterInputNumber" @paste="filterInputPaste" v-model="registerForm.phone" style="margin-bottom:0;" />
            <span style="display:block;padding-top:5px;font-size:14px;color:#999;">Please also add your country code.</span>
            <show-error :form-name="registerForm" prop-name="phone"></show-error>

            <label style="padding-top:20px;">Where are your company's headquarters?</label>
            <v-select label="name" track-by="id" v-model="selected_hq_countries" name="hq_country_id" id="hq_country_id" :options="countries" :placeholder="'Please choose'" @select="onHQCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQCountryRemove" :selected="selected_hq_countries"></v-select>
            <span style="display:block;padding-top:5px;font-size:14px;color:#999;">Start typing your country name in the box and press "choose" to select.</span>
            <show-error :form-name="registerForm" prop-name="hq_country_id"></show-error>


            <label>From which investor do you want to raise capital from in the future (high&nbsp;level)?</label>
            <ul class="pta-signup-list" style="margin-bottom:0;">
              <li><input type="checkbox" id="c1" name="c1" value="1" v-model="registerForm.investor_types" :true-value="[]" /><label for="c1">High-net-worth investor</label></li>
              <li><input type="checkbox" id="c2" name="c2" value="2" v-model="registerForm.investor_types" :true-value="[]" /><label for="c2">Family Offices</label></li>
              <li><input type="checkbox" id="c3" name="c3" value="3" v-model="registerForm.investor_types" :true-value="[]" /><label for="c3">Institutional Investor</label></li>
            </ul>
            <show-error :form-name="registerForm" prop-name="investor_types"></show-error>
            <label style="padding-top:20px;">From which main country should your ideal investor come from?</label>
            <v-select label="name" track-by="id" v-model="selected_main_countries" name="main_country_id" id="main_country_id" :options="countries" :placeholder="'Please choose'" @select="onMainCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onMainCountryRemove" :selected="selected_main_countries"></v-select>
            <show-error :form-name="registerForm" prop-name="main_country_id"></show-error>

            <h3 class="pta-signup-h3">ABOUT YOUR FUND / DEAL:</h3>
            <label>In which Asset Class are you investing?</label>
            <select @change="getFundTypes" v-model="registerForm.fund_category_id" id="continent_2_id" class="custom-select">
              <option value="">Please choose the fund category</option>
              <option v-for="fund_category in fund_categories" v-bind:value="fund_category.id">
                {{ fund_category.name }}
              </option>
            </select>
            <show-error :form-name="registerForm" prop-name="fund_category_id"></show-error>
            <select v-model="registerForm.fund_type_id" id="fund_type_id" class="custom-select" v-if="fund_types_cur && registerForm.fund_category_id" style="margin-top:10px;">
              <option value="">Please choose the fund type</option>
              <option v-for="fund_type in fund_types_cur" v-bind:value="fund_type.id">
                {{ fund_type.name }}
              </option>
            </select>
            <show-error :form-name="registerForm" prop-name="fund_type_id" v-if="registerForm.fund_category_id"></show-error>

              <label style="padding-top:30px;">Where are you investing primarily?</label>
              <v-select label="name" track-by="id" v-model="selected_asset_countries" name="asset_country_id" id="asset_country_id" :options="countries" :placeholder="'Please choose'" @select="onAssetCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onAssetCountryRemove" :selected="selected_asset_countries"></v-select>
              <show-error :form-name="registerForm" prop-name="asset_country_id"></show-error>


             <!--  <h3>or sign up with</h3>
              <ul class="login-social">
                <li class="icon-linkedin"><input type="radio" name="social" id="social-linkedin" /><label for="social-linkedin">LinkedIn</label></li>
                <li class="icon-google"><input type="radio" name="social" id="social-google" /><label for="social-google">Google</label></li>
                <li class="icon-microsoft"><input type="radio" name="social" id="social-microsoft" /><label for="social-microsoft">Microsoft</label></li>
              </ul> -->
              <div class="clear"></div>




              <div class="login-form-checkboxes">
                <input type="checkbox" name="is_fund" id="is_fund" v-model="registerForm.is_fund" />
                <label for="is_fund">Are you considering setting up a fund? (Tick for Yes)</label>
                <!--    <input type="checkbox" name="terms" id="terms" v-model="registerForm.tnc" />
                  <label for="terms">I agree to PropTechAM.ai’s website <a href="">Terms of Use</a> and <a href="">Privacy Policy</a>.</label>
                   <show-error style="margin-top:-20px;margin-bottom:20px;display:block;" :form-name="registerForm" prop-name="tnc"></show-error> -->
                <input type="checkbox" name="newsletter" id="newsletter" v-model="registerForm.newsletter" />
                <label for="newsletter">(Optional) Sign up to our Newsletter (you can unsubscribe at any time).</label>
              </div>
              <button class="button" :disabled="is_send" type="submit">PROCEED TO BOOK A CALL WITH US</button>
            </div>
          </form>
        </div>
        <div class="login-hiw">
          <h2>Here’s how it works</h2>
          <ul>
            <li><i>1</i><h3>Complete our first questionnaire</h3><p>Tell us more about your investor preferences and your investment offering</p></li>
            <li><i>2</i><h3>Get some free, suitable investor insights</h3><p>based on the information submitted</p></li>
            <li><i>3</i><h3>Book a video call with one of our experts</h3><p>Our team will review your offering and give you a quote</p></li>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
  </div>
</template>

<script>
    import vSelect from 'vue-multiselect'
    import guestFooter from '../../layouts/guest-footer.vue'
    import password from 'vue-password-strength-meter'

    export default {
        data() {
            return {
                registerForm: new Form ({
                    email: '',
                    /* password: '',
                    password_confirmation: '', */
                    first_name: '',
                    last_name: '',
                    company: '',
                    phone: '',
                    hq_country_id: [],
                    investor_types: [],
                    main_country_id: [],
                    asset_country_id: [],
                    fund_category_id: '',
                    fund_type_id: '',
                    /* phone: '',
                    company: '', */
                    newsletter: false,
                    is_fund: false,
                    tnc: false,
                    signup_type: 2
                }),
              fund_categories : '',
              fund_types : '',
              continents: '',
              countries: [],
              currencies: [],
              selected_hq_countries: [],
              selected_main_countries: [],
              selected_asset_countries: [],
              main_country_id: [],
              hq_country_id: [],
              asset_country_id: [],
              fund_types_cur : '',
              is_send: false,
              is_completed: false
            }
        },
        components: {
            guestFooter,password,vSelect
        },
        mounted(){
            $("body").addClass("page-register");
            if(!helper.featureAvailable('registration')){
                helper.featureNotAvailableMsg();
                return this.$router.push('/home');
            }
            this.prerequisite();
        },
        methods: {
            submit(){

              if(!this.is_send) {
                this.is_send = true;

                this.selected_hq_countries.forEach(function (item) {
                  this.registerForm.hq_country_id.push(item.id);
                }.bind(this));

                this.selected_main_countries.forEach(function (item) {
                  this.registerForm.main_country_id.push(item.id);
                }.bind(this));

                this.selected_asset_countries.forEach(function (item) {
                  this.registerForm.asset_country_id.push(item.id);
                }.bind(this));

                this.registerForm.post('/api/auth/register')
                    .then(response => {
                      toastr.success(response.message);
                     // this.$router.push('/video-call');
                      this.is_completed = true;
                    }).catch(error => {
                  helper.showErrorMsg(error);
                  this.is_send = false;
                });
              }
            },
            getConfig(config){
                return helper.getConfig(config);
            },
            prerequisite(){
              axios.get('/api/user/profile/questionnaire/pre-requisite')
                  .then(response => response.data)
                  .then(response => {
                    this.fund_categories  = response.fund_categories;
                    this.fund_types       = response.fund_types;
                    this.continents       = response.continents;
                    this.countries        = response.countries;
                    this.currencies        = response.currencies;
                  })
                  .catch(error => {
                    helper.showDataErrorMsg(error)
                  });
            },
            onHQCountrySelect(selectedOption){
              this.registerForm.errors.clear('hq_country_id');
              this.hq_country_id.push(selectedOption.id);
            },
            onHQCountryRemove(removedOption){
              this.hq_country_id.splice(this.hq_country_id.indexOf(removedOption.id), 1);
            },
          onMainCountrySelect(selectedOption){
            this.registerForm.errors.clear('main_country_id');
            this.main_country_id.push(selectedOption.id);
          },
          onMainCountryRemove(removedOption){
            this.main_country_id.splice(this.main_country_id.indexOf(removedOption.id), 1);
          },
          onAssetCountrySelect(selectedOption){
            this.registerForm.errors.clear('asset_country_id');
            this.asset_country_id.push(selectedOption.id);
          },
          onAssetCountryRemove(removedOption){
            this.asset_country_id.splice(this.asset_country_id.indexOf(removedOption.id), 1);
          },
          getFundTypes(){
            this.registerForm.fund_type_id = '';
            if(this.registerForm.fund_category_id){
              this.fund_categories.forEach(function(fund_category) {
                if(fund_category.id==this.registerForm.fund_category_id){
                  this.fund_types_cur = fund_category.fund_types;
                }
              }.bind(this));
            }
          },
          filterInputNumber($event){
            let keyValue = ($event.key ? $event.key : $event.which);
            console.log(keyValue);
            if((isNaN(parseFloat(keyValue)) || !isFinite(keyValue)) && keyValue!="+" && keyValue!=" " && keyValue!=")" && keyValue!="(" && keyValue!="Delete" && keyValue!="Backspace"){
              return $event.preventDefault();
            }

            /* let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            console.log(keyCode);
            if ((keyCode < 96 || keyCode > 105) && (keyCode < 48 || keyCode > 57) && keyCode !== 47 && keyCode !== 46 && keyCode !== 8 && keyCode !== 32 && keyCode !== 37 && keyCode !== 39 && keyCode !== 107 && keyCode !== 171 && keyCode !== 221) { // 47 is "/"
              return $event.preventDefault();
            } */
          },
          filterInputPaste($event){
            return $event.preventDefault();
          },
        }
    }
</script>
<style>
.login-form .button:disabled{
  opacity: 0.2;
}
.marginFull{
  margin-left:-80px;
  margin-right:-80px;
}
@media (max-width: 1440px)  {
  .marginFull{
    margin-left:-30px;
    margin-right:-30px;
  }
}
@media (max-width: 980px)  {
  .marginFull{
    margin-left:0px;
    margin-right:0px;
  }
}
</style>
